import { PageIcon } from "@src/packages/chime-ui";

export const EditSettings = () => (
  <PageIcon width="35%" src="/identity/icons/edit_settings.png" alt="Edit Settings Icon" />
);
